<template lang="html">

  <section class="home">

    <encabezado :data="'home'"></encabezado>
    <section class="banner-destacado-comunicacion container" v-if="comunicacionDestacada">
      <img :src="comunicacionDestacada.imagen" alt="imagen" v-if="comunicacionDestacada.imagen">
      <div class="content">
        <p class="fecha" v-html="comunicacionDestacada.fechaDesde"></p>
        <p class="titulo" v-html="comunicacionDestacada.descripcion"></p>
        <arrow-link class="arrow-link" :text="$t('ver_mas')" :to="comunicacionDestacada.enlace" :external="true" :blank="true"
        v-if="!!comunicacionDestacada.enlace"></arrow-link>
      </div>
      <!-- <a class="link-cover" :href="comunicacionDestacada.enlace" target="_blank" :title="$t('eventos.mas_informacion')"
        v-if="!!comunicacionDestacada.enlace"></a> -->
    </section>
    <home-empresa v-if="isEmpresa"></home-empresa>

    <home-alumno v-if="isAlumno"></home-alumno>



  </section>

</template>

<script lang="js">

import homeAlumno from '@/components/views/home/home-alumno';
import homeEmpresa from '@/components/views/home/home-empresa';
import arrowLink from '@/components/parts/icons/arrow-link'

import encabezado from '@/components/parts/encabezado';

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'home',
  mounted() {
    if (!!!this.logged) {
      this.logout();
    }
  },
  computed: {
    ...mapGetters({
      isAlumno: 'isAlumno',
      isEmpresa: 'isEmpresa',
      logged: 'getLogged',
      comunicaciones: 'getComunicaciones',
    }),
    comunicacionDestacada() {
      if (!Array.isArray(this.comunicaciones)) {
        return null;
      }
      return this.comunicaciones.find(comunicacion => comunicacion.destacada === true) || null;
    }
  },
  methods: {
    ...mapActions(['logout'])
  },
  components: {
    'home-alumno': homeAlumno,
    'home-empresa': homeEmpresa,
    'encabezado': encabezado,
    'arrow-link': arrowLink
  }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/views/home/home.vue